import React, { useEffect, useState, useCallback } from 'react'
import { ToastContainer, toast } from "react-toastify";
import { Link, useLocation } from "react-router-dom";
import { TextField, Button} from '@mui/material';

export default function CreateVideo() {
    const getCurrentDate = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = `${now.getMonth() + 1}`.padStart(2, '0');
        const day = `${now.getDate()}`.padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const [data, setData] = useState([]);
    const [title, setTitle] = useState('');
    const [videoUrl, setVideoUrl] = useState(null);
    const [fromDate, setFromDaate] = useState(getCurrentDate());
    const [toDate, setToDate] = useState(getCurrentDate());
    const [errors, setErrors] = useState('');
    const [DeleteId, setDeleteId] = useState(''); 
    const [isDeleted, setIsDeleted] = useState(false); 
    const [isSubmitting, setIsSubmitting] = useState(false); 
    const [loading, setLoading] = useState(false);
    const [breadcrumbs, setBreadcrumbs] = useState([{ label: 'Dashboard', url: '/Dashboard' }]);
    const location = useLocation();

    const handleTitleChange = (e) => {
        const selectedValue = e.target.value
        setTitle(selectedValue)
        setErrors((prevErrors) => ({
          ...prevErrors,
          title: selectedValue ? '' : 'Enter image Title'
        }));
    };

    const handleVideoURLChange = (e) => {
        const selectedValue = e.target.value
        setVideoUrl(selectedValue)
        setErrors((prevErrors) => ({
          ...prevErrors,
          videoUrl: selectedValue ? '' : 'Enter Video URl'
        }));
    };

    const handleFromDateChange = (e) => {
        setFromDaate(e.target.value)
    };

    const handleToDateChange = (e) => {
        setToDate(e.target.value)
    };

    const handleReset = () => {
      setTitle('');
      setVideoUrl('');
    }; 

    const fetchDetails = useCallback(async () => {
      try {
        const response = await fetch(`/api/getVideo`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ fromDate, toDate }),
        });
  
        if (response.ok) {
          const Data = await response.json();
          setData(Data);
        } else {
          console.error("Error fetching filtered data");
        }
      } catch (error) {
        console.error("Error fetching filtered data:", error);
      }
    }, [fromDate, toDate]);
  
    useEffect(() => {
      fetchDetails();
    }, [fetchDetails, fromDate, toDate]);

    const handleSubmit = async (e) => {
        setLoading(true);     
        if (isSubmitting) {
          return; 
        }

        if (!title || !videoUrl ) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                title: !title ? 'Title is required' : prevErrors.title,
                videoUrl: !videoUrl ? 'Video Url is required' : prevErrors.videoUrl,
            }));

            setLoading(false);
            setIsSubmitting(false);
            return;
        }  

        setIsSubmitting(true);   
        try {
            const response = await fetch(`/api/CreateVideo`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ title, videoUrl }),
            });
            if (response.ok) {
                const data = await response.json();
                toast.success(data.message);
                handleReset();
                fetchDetails();
            } else {
                const data = await response.json();
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error uploading', error);
        } finally {
            setLoading(false);
        }
        setIsSubmitting(false);
    }

    const handleConfirmation = async (VMID) => {
        setIsDeleted(true);
        setDeleteId(VMID)
    };

    const handleCancel = async () => {
        setIsDeleted(false);
        setDeleteId('')
    };

    const handleDelete = async (VMID) => {
      try {
        const response = await fetch(`/api/DeleteVideo/${VMID}`, {
          method: 'DELETE',
        });

        if (response.ok) {
          setData((prevData) => prevData.filter(item => item.VMID !== VMID));
          const data = await response.json();
          toast.success(data.message);
          setIsDeleted(false);
          setDeleteId('')
        } else {
          const data = await response.json();
          toast.error(data.error);
          setIsDeleted(false);
          setDeleteId('')
        }
      } catch (error) {
        console.error('Error deleting Subjects:', error);
      }
    };
    
    useEffect(() => {
      const currentRoute = location.pathname;
      const newBreadcrumbs = generateBreadcrumbs(currentRoute);
      setBreadcrumbs(newBreadcrumbs);
    }, [location]);
  
    const generateBreadcrumbs = (currentRoute) => {
      const breadcrumbsArray = [{ label: 'Dashboard', url: '/Dashboard' }];
  
      const routeParts = currentRoute.split('/').filter(Boolean);
      let urlSoFar = '';
      routeParts.forEach((part) => {
        urlSoFar += `/${part}`;
        breadcrumbsArray.push({ label: part, url: urlSoFar });
      });
  
      return breadcrumbsArray;
    };
   
  return (
    <>
      <div className='mt-24 mx-2'>
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              {breadcrumbs.map((breadcrumb, index) => (
                <li key={index} className={`breadcrumb-item${index === breadcrumbs.length - 1 ? ' active' : ''}`}>
                  {index === breadcrumbs.length - 1 ? (
                    breadcrumb.label
                  ) : (
                    <Link to={breadcrumb.url}>{breadcrumb.label}</Link>
                  )}
                </li>
              ))}
            </ol>
        </nav>
        <div className='shadow-sm p-2 mb-3 bg-white rounded'>
          <div className='row d-flex align-items-center'>
            <div className='col-12 mb-2'>
                <TextField label="Image Title" variant="standard" fullWidth value={title} onChange={handleTitleChange} helperText={errors.title} error={!!errors.title}/>
            </div>
            <div className='col-12 mb-2'>
                <TextField label={<span>Video URL (Open Your Video in Youtube.. Copy the part written after ?v= from url of youtube & paste in Vedio Url Field.. For Example :- https://www.youtube.com/watch?v=<span className='text-danger'>e1WbHnjZ544&t=37s</span>)</span>} variant="standard" fullWidth value={videoUrl} onChange={handleVideoURLChange} helperText={errors.videoUrl} error={!!errors.videoUrl}/>
            </div>
            <div className='col-6 mb-2'>
                <Button variant="outlined" color="primary" fullWidth onClick={handleSubmit}>Save</Button>
            </div>
            <div className='col-6 mb-2'>
                <Button variant="outlined" color="secondary" fullWidth onClick={handleReset}>Reset</Button>
            </div>
          </div>
        </div>
        <div className='shadow-sm p-2 mb-3 bg-white rounded'>
          <div className='row d-flex align-items-center'>
            <div className='col-6 mb-2'>
                <TextField label="From Date" variant="standard" fullWidth type='date' value={fromDate} onChange={handleFromDateChange} InputLabelProps={{shrink: true}} />
            </div>
            <div className='col-6 mb-2'>
                <TextField label="To Date" variant="standard" fullWidth type='date' value={toDate} onChange={handleToDateChange} InputLabelProps={{shrink: true}} />
            </div>
          </div>
        </div>
        <div className='shadow mb-5 rounded scrollOnXaxis' style={{ maxHeight: '100vh', overflowY: 'auto' }}>
            <table className='table table-nowrap mb-0 mt-0'>
              <thead className='table-primary' style={{ position: 'sticky', top: '0', zIndex: '1', marginTop: '1rem'}}>
                <tr style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  <th>#</th>
                  <th>Title</th>
                  <th>Video</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
              {data.map((item, index) => (
                  <tr key={index} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    <td>{index + 1}</td>
                    <td>{item.VideoTitle}</td>
                    <td><iframe width="100%" height="75" src={item.VideoURL} title={item.VideoTitle} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" className="embed-responsive-item" allowFullScreen></iframe></td>
                    <td><span className='inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 inset-ring inset-ring-red-600/10' onClick={() => handleConfirmation(item.VMID)}><i className="bi bi-trash3-fill fs-6"></i></span></td>
                  </tr>
                ))}
              </tbody>
            </table>
        </div>
      </div>
      {isDeleted && (
        <div className="modal-backdrop show"></div>
      )}
      <div className={`modal fade ${isDeleted ? 'show' : ''}`} style={{ display: isDeleted ? 'block' : 'none' }} tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content shadow-lg p-3 mb-5 bg-white rounded">
            <div className="modal-header">
              <h5 className="modal-title">Delete <strong>Video?</strong></h5>
            </div>
            <div className="modal-body">
              <p>This Will Delete Video <span className='text-danger'>Permannently</span></p>
              <div className='d-flex flex-row-reverse '>
              <button className='btn btn-danger mx-2' onClick={() => handleDelete(DeleteId)}>Delete</button>
              <button className='btn btn-secondary mx-2' onClick={handleCancel}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loading && (
        <div className="modal-backdrop show"></div>
      )}
      <div className={`modal fade ${loading ? 'show' : ''}`} style={{ display: loading ? 'block' : 'none' }} tabIndex="-1" role="dialog">
        <div id="preloader">
          <div className="bar-container">
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
          <h1>Loading...</h1>
        </div>
      </div>
      <ToastContainer />
    </>
  )
}


